<template>
  <div v-if="visible" class="notification">
      <div class="notification-body box" :class="notificationType">
        <h3>{{headText}}</h3>
        <p>{{bodyText}}</p>
      </div>
  </div>    
</template>

<script>
import {bus} from '../../main'
export default {
  name: 'notification',
  data: () => {
    return {
        visible: false,
        headText: false,
        bodyText: false,
        notificationType: ''
    }
  },
  methods: {
    showModal(emitData){
        const {headText, bodyText, autoDismiss, notificationType} = emitData;
        this.headText = headText;
        this.bodyText = bodyText;
        this.notificationType = notificationType;
        this.visible = true;

        if (autoDismiss) {
            setTimeout(() => {
                this.visible = false;
            }, 3000);
        }
    }
  },
  created(){
    bus.$on('showModal', this.showModal);
  }
}
</script>

<style scoped>
    .notification {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 0 10rem;
        z-index: 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-start;
        background: rgba(69, 79, 140, 0.9);
    }
    .notification-body {
        padding: 1rem 2rem;
        border-top: 10px solid #fff;
        border-radius: 0px;
        min-width: 600px;
        margin-top: 5rem;
    }
    .error{
        border-color: #FF9E01;
    }
</style>